var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'vld-parent',style:({height : '80vh'})},[_c('loading',{attrs:{"active":true,"is-full-page":false,"loader":'bars',"color":'#00afd3',"height":90,"width":90,"opacity":0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }